// Internal actions for the googleTagManager SubDomain
// IMPORTANT: Prefix your string with "GTM" in order to prevent naming collisions with the application constants
export const Actions = Object.freeze({
  SIGN_UP_CLICKED: 'GTM_SIGN_UP_CLICKED',
  UPGRADE_CTA_CLICKED: 'GTM_UPGRADE_CTA_CLICKED',
  UPGRADE_DISCOUNT_PLAN_LINK_CLICKED: 'GTM_UPGRADE_DISCOUNT_PLAN_LINK_CLICKED',
  APP_STORE_LINK_CLICKED: 'GTM_APP_STORE_LINK_CLICKED',
  VIEW_PLANS_CLICKED: 'GTM_VIEW_PLANS_CLICKED',
});

// External events that are sent to Google Tag Manager
export const EventNames = Object.freeze({
  AUTHENTICATION: 'authentication',
  UPGRADE_CTA_CLICK: 'upgradeCtaClick',
  UPGRADE_DISCOUNT_PLAN_LINK_CLICKED: 'upgradeDiscountPlanLinkClick',
  SIGN_UP_CLICK: 'signUpClick',
  VIEW_PLANS_CLICK: 'viewPlansClick',
  APP_STORE_CTA_CLICK: 'appStoreCtaClick',
  ACQUIRE_OFFER: 'acquireOffer',
});

// These variable names match up with the "User Defined" Data Layer props in the GTM admin tool.
// Do not change these without also updating the variable names in the GTM admin tool.
export const Variables = Object.freeze({
  EVENT: 'event',
  AUTH_TYPE: 'authType',
  CAMPAIGN_ID: 'campaignId',
  DISCOUNT_TYPE: 'discountType',
  DURATION_TYPE: 'durationType',
  DURATION_TIME: 'durationTime',
  IS_TRIAL: 'isTrial',
  LID: 'lid',
  OFFER_PRICE: 'offerPrice',
  OS_NAME: 'osName',
  PREVIOUS_DISCOUNT_TYPE: 'previousDiscountType',
  PREVIOUS_TIER: 'previousTier',
  SELECTED_TIER: 'selectedTier',
  SELECTED_DISCOUNT_TYPE: 'selectedDiscountType',
  SELECTED_IS_TRIAL: 'selectedIsTrial',
  SKU: 'sku',
  SPECIAL_OFFER_CODE: 'specialOfferCode',
  TIER: 'tier',
  TIMES_RENEWABLE: 'timesRenewable',
  ZIP_CODE: 'zipCode',
});
